import moment from "moment-jalaali";

const escapeHtml = (value) =>
  String(value === undefined || value === null ? "" : value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

const formatDate = (value) => {
  if (!value) return "";
  const date = moment(value);
  return date.isValid() ? date.format("jYYYY/jMM/jDD") : value;
};

const getPersonInformation = (table) => {
  const profile = table && table.props && table.props.user && table.props.user.profile;
  return {
    firstName: profile && profile.firstName ? profile.firstName : "",
    lastName: profile && profile.lastName ? profile.lastName : "",
    personnelId: profile && profile.personnelId ? profile.personnelId : "",
    recruitmentType: table && table.props && table.props.recruitmentType ? table.props.recruitmentType : "-",
  };
};

const getOrderedColumns = (columns) =>
  columns
    .slice()
    .sort((a, b) => (a.priority === undefined ? 100 : a.priority) - (b.priority === undefined ? 100 : b.priority));

const normalizeTitle = (value) =>
  String(value || "")
    .replace(/ي/g, "ی")
    .replace(/ك/g, "ک")
    .replace(/\s+/g, " ")
    .trim();

const getColumnWeight = (column) => {
  const title = normalizeTitle(column.title);
  if (title === "ساعت کاری" || title === "ساعات کاری") return 1.8;
  if (title === "نام و نام خانوادگی") return 1.65;
  if (title === "جایگاه") return 1.45;
  if (title === "وضعیت حضور" || title === "وضعیت") return 1.35;
  if (title === "نوع استخدام") return 1.2;
  if (title === "تاریخ") return 1.25;
  if (title === "روز" || title === "روز هفته") return 1.05;
  if (title === "کد پرسنلی" || title === "شماره پرسنلی") return 0.9;
  return 0.82;
};

const renderColumnWidths = (columns) => {
  const totalWeight = columns.reduce((sum, column) => sum + getColumnWeight(column), 0);
  return columns
    .map((column) => `<col style="width: ${(getColumnWeight(column) * 100 / totalWeight).toFixed(3)}%" />`)
    .join("");
};

const isNumericValue = (value) =>
  /^[\d۰-۹٠-٩:\/\.\-]+$/.test(String(value || "").trim());

const splitHeaderTitle = (title) => {
  const words = normalizeTitle(title).split(" ").filter(Boolean);
  if (words.length < 2) return [words[0] || ""];
  const middle = Math.ceil(words.length / 2);
  return [words.slice(0, middle).join(" "), words.slice(middle).join(" ")];
};

const renderHeader = (columns) =>
  columns
    .map(
      (column) => `
        <th>
          ${splitHeaderTitle(column.title)
            .map((line) => `<span>${escapeHtml(line)}</span>`)
            .join("")}
        </th>`
    )
    .join("");

const renderRows = (rows, columns) =>
  rows
    .map((row) => {
      const isFooter = row && row._props && row._props.type === "footer";
      const cells = columns
        .map((column) => {
          let value = row ? row[column.key] : "";
          if (column.valuesType === "date") value = formatDate(value);
          const isDateColumn = normalizeTitle(column.title) === "تاریخ";
          const cellClass = isDateColumn ? "date-cell" : isNumericValue(value) ? "numeric-cell" : "text-cell";
          return `<td class="${cellClass}" title="${escapeHtml(value)}"><span>${escapeHtml(value)}</span></td>`;
        })
        .join("");
      return `<tr class="${isFooter ? "footer-row" : ""}">${cells}</tr>`;
    })
    .join("");

const renderDescriptions = (properties) => {
  const descriptions = properties && properties.descriptions;
  if (!descriptions || !descriptions.length) return "";
  return `<div class="report-descriptions">${descriptions
    .map((item) => `<span>${escapeHtml(item)}</span>`)
    .join("")}</div>`;
};

const renderReport = (table, columns, properties, pageNumber, reportTitle) => {
  const person = getPersonInformation(table);
  const range = properties && properties.range;
  return `
    <section class="report-page">
      <header class="report-head">
        <div class="person-info">
          <div>نام: <strong>${escapeHtml(person.firstName)}</strong></div>
          <div>نام خانوادگی: <strong>${escapeHtml(person.lastName)}</strong></div>
          <div>شماره پرسنلی: <strong>${escapeHtml(person.personnelId)}</strong></div>
          <div>نوع استخدام: <strong>${escapeHtml(person.recruitmentType)}</strong></div>
        </div>
        <div class="report-title">${escapeHtml(reportTitle)}</div>
        <div class="report-range">
          <div>تاریخ گزارش‌گیری: <strong>${formatDate(properties && properties.date)}</strong></div>
          <div>${range ? `از تاریخ: <strong>${formatDate(range.start)}</strong> تا تاریخ: <strong>${formatDate(range.stop)}</strong>` : ""}</div>
          <div>صفحه: <strong>${pageNumber}</strong></div>
        </div>
      </header>
      <table>
        <colgroup>${renderColumnWidths(columns)}</colgroup>
        <thead><tr>${renderHeader(columns)}</tr></thead>
        <tbody>${renderRows((table && table.body) || [], columns)}</tbody>
      </table>
      ${renderDescriptions(properties)}
    </section>`;
};

export default function printReportFormat2(
  columns = [],
  dataPrint = [],
  properties = {},
  reportTitle = "گزارش",
  selectedColumns = []
) {
    const printableColumns = Array.isArray(selectedColumns) && selectedColumns.length
      ? columns.filter((column) => selectedColumns.indexOf(column.key) > -1)
      : columns;
    const orderedColumns = getOrderedColumns(printableColumns);
    const newWindow = window.open("", "_blank");

    if (!newWindow) {
      app.message("مرورگر اجازه باز کردن پنجره چاپ را نداد.", "error");
      return;
    }

    const reports = dataPrint
      .filter((table) => table && table.body && table.body.length)
      .map((table, index) => renderReport(table, orderedColumns, properties, index + 1, reportTitle))
      .join("");

    newWindow.document.write(`
      <!doctype html>
      <html dir="rtl">
        <head>
          <meta charset="utf-8" />
          <title>پرینت ${escapeHtml(reportTitle)}</title>
          <style>
            @font-face { font-family: Samim; src: url('/src/fonts/Samim-FD.ttf'); }
            @page { size: A4 landscape; margin: 3mm; }
            * { box-sizing: border-box; }
            html, body { width: 100%; margin: 0; padding: 0; }
            body { direction: rtl; font-family: Samim, Tahoma, sans-serif; color: #000; }
            .report-page { width: 100%; min-height: 198mm; page-break-after: always; }
            .report-page:last-child { page-break-after: auto; }
            .report-head { height: 16mm; display: grid; grid-template-columns: 36% 28% 36%; align-items: center; padding: 0 2mm 1.5mm; }
            .person-info { display: grid; grid-template-columns: 1fr 1fr; gap: 1mm 4mm; font-size: 9px; line-height: 1.5; }
            .report-title { text-align: center; font-size: 20px; font-weight: bold; }
            .report-range { text-align: left; font-size: 9px; line-height: 1.6; }
            table { width: 100%; border-collapse: collapse; table-layout: fixed; direction: rtl; }
            th, td { border: 1px solid #111; text-align: center; vertical-align: middle; }
            th { height: 12mm; padding: 1mm 0.35mm; background: #c8c8c8; font-size: 9px; font-weight: bold; line-height: 1.35; overflow: hidden; }
            th span { display: block; max-width: 100%; white-space: nowrap; }
            td { height: 5.25mm; padding: 0.5mm 0.3mm; line-height: 1.15; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
            td span { display: block; width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
            td.numeric-cell { font-size: 11px; font-weight: bold; }
            td.text-cell { font-size: 8.5px; font-weight: 600; }
            td.date-cell { direction: ltr; font-size: 8px; font-weight: bold; letter-spacing: -0.15px; text-overflow: clip; }
            td.date-cell span { overflow: visible; text-overflow: clip; }
            .footer-row td { background: #dedede; font-size: 10.5px; font-weight: bold; }
            .report-descriptions { display: flex; flex-wrap: wrap; gap: 2mm 6mm; padding-top: 2mm; font-size: 8.5px; }
            @media print {
              body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
            }
          </style>
        </head>
        <body>${reports}</body>
      </html>`);
    newWindow.document.close();
    newWindow.setTimeout(() => {
      newWindow.focus();
      newWindow.print();
    }, 500);
}
